<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form label-width="170px">
        <el-form-item label="主题：" label-width="40%">
          <p>{{ dataForm.TrainTitle }}</p>
        </el-form-item>
        <el-form-item label="预约人数：" label-width="40%">
          <p>{{ count }}</p>
        </el-form-item>
        <el-form-item label="开馆时间：" label-width="40%">
          <p>{{ (dataForm.OpenTime * 1000) | formatDate2  }}&nbsp;{{dataForm.TimeStart}}-{{dataForm.TimeEnd}}</p>
        </el-form-item>
      </el-form>
      <el-tabs
        v-model="activeName"
        type="border-card"
        @tab-click="handleTabsClick"
      >
        <el-tab-pane label="个人" name="personal">
          <p style="font-weight:bold">
            预约人员信息
            <el-button
              size="small"
              type="danger"
              @click="btnUpdateIsAttended"
              style="margin-left:5px"
              :disabled="isEdit"
              >确认</el-button
            >
          </p>
          <el-table
            border
            hightlight-current-row
            :header-cell-class-name="headerRow"
            :data="personalModel"
            :max-height="tableMaxHeight()"
            v-loading="isloading"
            @selection-change="onSelectionChange"
          >
            <el-table-column
              type="selection"
              width="50"
              align="center"
              v-bind:selectable="chkstu"
            ></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="Name"
              label="姓名"
              sortable
            ></el-table-column>
            <el-table-column
              prop="Sex"
              label="性别"
              sortable
              :formatter="Sex"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="Phone"
              label="手机号"
              sortable
              align="right"
              width="120"
            ></el-table-column>
            <el-table-column 
              prop="IsChild"
              label="是否带儿童"
              sortable
              :formatter="IsChild"
              width="125">
              
            </el-table-column>
            <el-table-column
              prop="IsAttended"
              label="是否到场"
              sortable
              :formatter="IsAttended"
              width="105"
            ></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button
                  v-access:modify
                  v-if="!scope.row.IsAttended == 1"
                  type="text"
                  size="mini"
                  @click="innerUpdateIsAttended(scope.row)"
                  >确认</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="团体" name="group">
          <p style="font-weight:bold">预约人员信息</p>
          <el-table
            border
            hightlight-current-row
            :header-cell-class-name="headerRow"
            :data="groupModel"
            :max-height="tableMaxHeight()"
            v-loading="isloading"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="Name"
              label="机构名称"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="ContactUser"
              label="联系人姓名"
              sortable
              width="120"
            ></el-table-column>
            <el-table-column
              prop="Phone"
              label="手机号"
              sortable
              align="right"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="Email"
              label="邮箱"
              sortable
              align="right"
              width="180"
            ></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button
                  v-access:modify
                  type="text"
                  size="mini"
                  @click="innerDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </el-tabs>
      <ModuleDetail_library_Group
        v-if="formVisible"
        :dataForm="formData"
        :formTitle="formTitle_library_Group"
        @formCallBack="formCallBack"
      ></ModuleDetail_library_Group>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModuleDetail_library_Group from "@/modules/zjrc/pages/train/trainapply/detail_Library_group";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      headerRow: "header-row",
      isConfirm: false,
      isdisabled: false,
      isloading: false,
      width: "70%",
      activeName: "personal",

      total: 0,
      currentPage: 1,
      pageSize: 15,
      MemberType: 1,
      personalModel: [],
      groupModel: [],

      formVisible: false,
      formData: {},
      formTitle_library_Group: "",

      batchId: "",
      count: 0,
      isEdit: true
    };
  },
  mounted() {
    this.loadData();
    this.loadCount();
  },
  components: {
    OfDialog,
    OfPagination,
    ModuleDetail_library_Group
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //初始化数据
    loadData() {
      this.isloading=true;
      let params={
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        Periods:this.dataForm.Id,
        MemberType:this.MemberType
      }
      api.QueryLifeApplyByPeriods(params).then(rep => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          if (this.MemberType == 1) {
            this.personalModel = rep.data.Data.rows;
          } else {
            this.groupModel = rep.data.Data.rows;
          }
        }
        this.isloading=false;
      });
    },
    loadCount() {
      let params={Periods:this.dataForm.Id}
      api.QueryLifeApplyCount(params).then(rep => {
        if (rep.data.Code == 0) {
          this.count = rep.data.Data;
        }
      });
    },
    //tab切换
    handleTabsClick(tab, event) {
      if (tab.name == "personal") {
        this.MemberType = 1;
      } else {
        this.MemberType = 2;
      }
      this.loadData();
    },
    Sex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    },
    IsAttended(rowData) {
      return rowData.IsAttended == 1 ? "是" : "否";
    },
    IsChild(rowData) {
      return rowData.IsChild == 1 ? "是" : "否"
    },
    innerDetail(rowData) {
      this.formData = rowData;
      this.formTitle_library_Group = "预约人员信息";
      this.formVisible = true;
    },
    formCallBack(data) {
      this.formVisible = false;
      if (data) {
        this.activeName = "group";
        this.currentPage = 1;
        this.MemberType = 1;
        this.loadData();
      }
    },
    onSelectionChange(rowItems) {
      this.isEdit = !rowItems.length > 0;
      if (rowItems.length) {
        const ids = [];
        for (var i = 0; i < rowItems.length; i++) {
          ids.push(rowItems[i].Id);
        }
        this.batchId = ids.join(",");
      }
    },
    updateIsAttended(ids) {
      let params={Id:ids}
      api.UpdateLifePersonIsAttendedByApplyId(params)
        .then(rep => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
            this.loadData();
            this.batchId = "";
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error"
            });
          }
        })
        .catch(e => {
          this.$message({
            message: e.toString(),
            type: "error"
          });
        });
      this.isloading = false;
    },
    innerUpdateIsAttended(rowData) {
      this.isloading = true;
      this.$confirm("请确认是否到场？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.updateIsAttended(rowData.Id);
      });
    },
    btnUpdateIsAttended() {
      this.isloading = true;
      if (this.batchId == "") return;
      this.$confirm("请确认是否到场？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.updateIsAttended(this.batchId);
        })
        .catch(e => {
          this.isloading = false;
        });
    },
    chkstu(rowData) {
      return rowData.IsAttended == 1 ? false : true;
    }
  }
};
</script>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}
.title {
  font-weight: bold;
  float: left;
  margin-right: 10px;
}
</style>
